import { logger } from '@/services/logger';

export const isDefaultFieldValue = ({ key, value }: { key: string; value: string }) => {
    return value === `{{add_${key}}}`;
};

const isValidScriptFields = ({ scriptFields, inputFields }: { scriptFields: string[]; inputFields: Record<string, string> }) => {
    return scriptFields.every(
        field =>
            inputFields[field] &&
            !isDefaultFieldValue({
                key: field,
                value: inputFields[field],
            })
    );
};

const mergeScriptWithInput = ({ script = '', inputFields }: { script?: string; inputFields: Record<string, string> }) => {
    return Object.entries(inputFields).reduce((acc, [key, value]) => {
        return acc.replaceAll(`{{${key}}}`, value);
    }, script);
};

export const getScriptWithInput = ({
    script,
    inputFields,
    scriptFields,
    campaignId,
}: {
    script: string;
    inputFields: Record<string, string>;
    scriptFields: string[];
    campaignId: string;
}): string | null => {
    if (!isValidScriptFields({ scriptFields, inputFields })) {
        logger.error('Missing input fields', { campaignId, inputFields, scriptFields });

        return null;
    }

    return mergeScriptWithInput({ script, inputFields });
};
